import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { ErrBanner } from '../../hooks/useApi';
import UserSection from './UserSection';
import RoleManagement from '../RoleManagement/RoleManagement';
import './UserManagement.css';

const SUB_TABS = [
  { id: 'UserManagement', label: '👥 Users' },
  { id: 'RoleManagement', label: '🔐 Roles' },
];

export default function UserManagement({ subPage = 'UserManagement' }) {
  const { canAccess } = useAuth();
  const [tab, setTab] = useState(subPage);

  useEffect(() => {
    setTab(subPage);
  }, [subPage]);

  if (!canAccess('roles')) {
    return (
      <div className="um-page">
        <ErrBanner msg="Access Denied: You do not have permission to manage users." />
      </div>
    );
  }

  return (
    <div className="um-page">
      <div className="page-header">
        <h2 className="page-title">Users & Roles</h2>
      </div>

      <div className="sub-tab-bar">
        {SUB_TABS
          .filter(t => {
            if (t.id === 'RoleManagement') {
              return canAccess('roles');
            }
            return canAccess('users');
          })
          .map(t => (
            <button
              key={t.id}
              className={`sub-tab ${tab === t.id ? 'active' : ''}`}
              onClick={() => setTab(t.id)}
            >
              {t.label}
            </button>
          ))}
      </div>

      <div className="tab-content" style={{ marginTop: '20px' }}>
        {tab === 'UserManagement' && <UserSection />}
        {tab === 'RoleManagement' && <RoleManagement />}
      </div>
    </div>
  );
}
